export default "__VITE_ASSET__CNInLq6v__"